import Swiper, { A11y, Keyboard, Navigation } from 'swiper';

import '../../sass/template-parts/news-carousel.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $newsCarousels = document.querySelectorAll('.news-carousel');

    if (!$newsCarousels) return;

    $newsCarousels.forEach($newsCarousel => {
        const $carousel = $newsCarousel.querySelector('.news-carousel__carousel');
        const $carouselSlides = $newsCarousel.querySelectorAll('.news-carousel__slide');
        const $keylineCards = $newsCarousel.querySelector('.news-card-keyline');
        const $blockCards = $newsCarousel.querySelector('.news-card-block');
        const $carouselNext = $newsCarousel.querySelector('.news-carousel__navigation--next');
        const $carouselPrev = $newsCarousel.querySelector('.news-carousel__navigation--prev');

        const navigationButtonsPosition = () => {
            if (!$carouselNext || !$carouselPrev) return;

            let buttonTopPosition = '50%';

            if ($keylineCards) {
                const $image = $keylineCards.querySelector('.news-card-keyline__image');

                if (!$image) return;

                buttonTopPosition = `${$image.clientHeight / 2}px`;
            }

            if ($blockCards) {
                const $details = $blockCards.querySelector('.news-card-block__details');

                if (!$details) return;

                buttonTopPosition = `${$details.clientHeight / 2}px`;
            }

            $carouselNext.style.top = buttonTopPosition;
            $carouselPrev.style.top = buttonTopPosition;
        };

        const initCarousel = () => {
            const carousel = new Swiper($carousel, {
                modules: [ A11y, Keyboard, Navigation ],
                slidesPerView: 'auto',
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                speed: noMotionPreference.matches ? 300 : 0
            });

            if (carousel) {
                carousel.on('slideChange', () => {
                    $carouselPrev.classList.remove('news-carousel__navigation--hide');
                });
            }

            if ($carouselNext && $carouselSlides?.length) {
                $carouselNext.addEventListener('click', () => {
                    const endIndex = window.innerWidth >= 1164 ? carousel.activeIndex + 3 : carousel.activeIndex + 2;

                    if (endIndex < $carouselSlides.length) {
                        carousel.slideNext();
                    } else {
                        carousel.slideTo(0);
                    }
                });
            }

            if ($carouselPrev && $carouselSlides?.length) {
                $carouselPrev.addEventListener('click', () => {
                    console.log(carousel.activeIndex);
                    if (carousel.activeIndex === 0) {
                        carousel.slideTo($carouselSlides?.length);
                    } else {
                        carousel.slidePrev();
                    }
                });
            }
        }

        window.addEventListener('resize', () => {
            navigationButtonsPosition();
        });

        window.addEventListener('load', () => {
            navigationButtonsPosition();
        });

        initCarousel();
        navigationButtonsPosition();
    })
})();
